export const moduleConfig = {
    entityKey: 'binding-drift-reconciliation',
    titles: {
        singular: 'Binding Drift Report',
        plural: 'Binding Drift Reconciliation'
    }
}

export const initialSortState = {
    column: 'runStartedAt',
    direction: 'desc',
};
